<script lang="ts" setup>
  import type { PropType } from 'vue';

  type Item = {
    link: string,
    header: string,
  }

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: { type: String, required: true },
    headerType: { type: String, required: false },
    content: { type: String, required: false },
    items: { type: Array as PropType<Item[]>, required: false, default: [] },
  });
</script>
<template>
  <SfSection :title="header" :headerType class="configurator-titles-block">
    <QuillContent v-if="content" :content />
    <ul v-if="items.length > 0" class="configurator-titles-block__list">
      <li v-for="item in items">
        <RouterLink :href="item.link" class="configurator-titles-block__link" target="_blank">
          <SfIconLink aria-hidden="true" />
          {{ item.header }}
        </RouterLink>
      </li>
    </ul>
  </SfSection>
</template>
<style lang="scss" scoped>
  .configurator-titles-block {
    display: flex;
    flex-direction: column;

    &__list {
      display: flex;
      flex-direction: column;
      list-style: none;
    }

    &__link {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 1.125rem;
      font-weight: var(--font-weight-semi);
      padding: 0.5rem 0;
      text-decoration: underline;
      text-decoration-color: transparent;
      transition: text-decoration-color 0.2s ease-out;

      @media(hover: hover) {
        &:hover {
          text-decoration-color: var(--primary-color);
        }
      }
    }

    @media (max-width: 992px) {
      &__list {
        padding-left: 0.625rem;
        padding-right: 0.625rem;
      }
    }
  }
</style>
